import { OnlyParamsScreenshotterRequest } from '../ScreenshotterRequest';

export const enum GetScreenshotRequestReturnType {
  BASE64 = 'base64',
  URL = 'url',
}

export const enum GetScreenshotRequestFormat {
  IMG = 'img',
  PDF = 'pdf',
}

export type GetScreenshotConfigParams = {
  width: string;
  height: string;
  address: string;
  scaleFactor?: string;
  quality?: string;
  type?: GetScreenshotRequestReturnType;
  format?: GetScreenshotRequestFormat;
  timeout: number;
};

export type GetScreenshotGetQueryParams = GetScreenshotConfigParams;

export type GetThumbnailScreenshotGetQueryParams = GetScreenshotConfigParams & {
  userId: string;
};

export type GetScreenshotGetRequest =
  OnlyParamsScreenshotterRequest<GetScreenshotGetQueryParams>;

export type GetScreenshotGetResponse = string;
